import {
  Map,
} from 'immutable';
import {
  PURGE,
  REHYDRATE,
} from 'redux-persist';

import {
  RESET,
  SET_NEW_VERSION_AVAILABLE,
  SET_STATE,
} from './actionTypes';
import {
  STATE__UNAUTHORIZED,
} from './constants';

const initialState = Map({
  // Środowisko.
  environment: ENVIRONMENT,
  // Flaga określająca, czy nowa wersja aplikacji jest dostępna.
  isNewApplicationVersionAvailable: false,
  // Stan.
  state: STATE__UNAUTHORIZED, // TODO Docelowo: STATE__INITIALIZING
});

export default (state = initialState, action) => {
  switch (action.type) {
    case PURGE:
      return initialState;

    case REHYDRATE: {
      if (action?.payload?.application) {
        return action.payload.application
          .set('isNewApplicationVersionAvailable', false);
      }

      return state
        .set('state', STATE__UNAUTHORIZED); // TODO Docelowo: STATE__INITIALIZING
    }

    case RESET:
      return initialState;

    case SET_NEW_VERSION_AVAILABLE:
      return state
        .set('isNewApplicationVersionAvailable', action.payload);

    case SET_STATE:
      return state
        .set('state', action.payload);

    default:
      return state;
  }
};
